type TFunction = (key: string, opts?: Record<string, unknown>) => string;

const SIZE_PATTERN = /(\d+)\s*bytes?\s*>\s*(\d+)\s*bytes?|image exceeds (\d+)\s*MB/i;

function bytesToMb(bytes: number): string {
  return (bytes / (1024 * 1024))
    .toFixed(2)
    .replace(/\.?0+$/, '')
    .replace('.', ',');
}

function extractFileSizeMb(errorMessage: string): string | null {
  // Backend (AIDocumentTooLarge) phrases it "<n> bytes exceeds <m> bytes"; keep `>` for legacy messages.
  const bytesMatch = errorMessage.match(/(\d+)\s*bytes?\s*(?:>|exceeds)/);
  return bytesMatch ? bytesToMb(Number(bytesMatch[1])) : null;
}

function extractMaxSizeMb(errorMessage: string): string {
  const maxBytesMatch = errorMessage.match(/(?:>|exceeds)\s*(\d+)\s*bytes/);
  if (maxBytesMatch) {
    return bytesToMb(Number(maxBytesMatch[1]));
  }
  const mbMatch = errorMessage.match(/exceeds (\d+)\s*MB/i);
  if (mbMatch) {
    return mbMatch[1];
  }
  // Unparseable message: fall back to the image limit (3.75 MB), the common case.
  return '3,75';
}

export function formatExtractionError(errorMessage: string, t: TFunction): string {
  if (SIZE_PATTERN.test(errorMessage) || errorMessage.includes('too large')) {
    const fileSize = extractFileSizeMb(errorMessage);
    const maxSize = extractMaxSizeMb(errorMessage);
    return t('documents.extraction.errors.fileTooLarge', {
      fileSize: fileSize ?? '?',
      maxSize,
    });
  }

  if (errorMessage.includes('AI service is disabled')) {
    return t('documents.extraction.errors.serviceDisabled');
  }

  if (
    errorMessage.includes('AI provider unavailable') ||
    errorMessage.includes('unavailable') ||
    errorMessage.includes('timeout')
  ) {
    return t('documents.extraction.errors.serviceUnavailable');
  }

  return t('documents.extraction.errors.generic');
}
